import { useMemo } from 'react';
import { extractTags, addTagToField } from '../utils/tags';

function AlertForm({
  newAlert,
  setNewAlert,
  guardarAlerta,
  editingAlertId,
  cancelarEdicionAlerta,
  projectActors,
  allAlerts = []
}) {
  const suggestedTags = useMemo(() => extractTags(allAlerts), [allAlerts]);

  const agregarTag = (tag) => {
    setNewAlert({ ...newAlert, tags: addTagToField(newAlert.tags, tag) });
  };

  const seleccionarActor = (nombreActor) => {
    const actor = projectActors.find(a => a.nombre === nombreActor);
    if (actor) {
      setNewAlert({
        ...newAlert,
        actor: nombreActor,
        latitud: actor.latitud || '',
        longitud: actor.longitud || ''
      });
    } else {
      setNewAlert({ ...newAlert, actor: nombreActor });
    }
  };

  const actorSeleccionado = projectActors.find(a => a.nombre === newAlert.actor);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>
        {editingAlertId ? 'Editar alerta' : 'Nueva alerta territorial'}
      </h2>

      {/* ACTOR — primero */}
      <div style={styles.actorBox}>
        <div style={styles.actorLabel}>Actor territorial vinculado</div>
        <select
          style={styles.actorSelect}
          value={newAlert.actor || ''}
          onChange={(e) => seleccionarActor(e.target.value)}
        >
          <option value="">Selecciona el actor al que pertenece esta alerta</option>
          {projectActors.map((actor) => (
            <option key={actor.id} value={actor.nombre}>
              {actor.nombre}
            </option>
          ))}
        </select>

        {actorSeleccionado && (
          <div style={styles.actorPreview}>
            <span style={styles.actorNombre}>{actorSeleccionado.nombre}</span>
            <span style={styles.actorMeta}>
              {actorSeleccionado.sector} · {actorSeleccionado.comuna} ·
              Riesgo {actorSeleccionado.riesgo} · Influencia {actorSeleccionado.influencia}
            </span>
            <span style={styles.actorNota}>
              ✓ Coordenadas heredadas automáticamente
            </span>
          </div>
        )}
      </div>

      {/* CAMPOS DE LA ALERTA */}
      <div style={styles.grid}>
        <input
          style={{ ...styles.input, gridColumn: 'span 2' }}
          placeholder="Título de la alerta — describe qué ocurrió"
          value={newAlert.titulo || ''}
          onChange={(e) => setNewAlert({ ...newAlert, titulo: e.target.value })}
        />

        <select
          style={styles.input}
          value={newAlert.nivel || ''}
          onChange={(e) => setNewAlert({ ...newAlert, nivel: e.target.value })}
        >
          <option value="">Nivel</option>
          <option value="Bajo">Bajo</option>
          <option value="Medio">Medio</option>
          <option value="Alto">Alto</option>
          <option value="Crítico">Crítico</option>
        </select>

        <select
          style={styles.input}
          value={newAlert.tipo || ''}
          onChange={(e) => setNewAlert({ ...newAlert, tipo: e.target.value })}
        >
          <option value="">Tipo de alerta</option>
          <option value="Movilización">Movilización</option>
          <option value="Declaración pública">Declaración pública</option>
          <option value="Cambio de posición">Cambio de posición</option>
          <option value="Organización territorial">Organización territorial</option>
          <option value="Presión mediática">Presión mediática</option>
          <option value="Judicialización">Judicialización</option>
          <option value="Reunión territorial">Reunión territorial</option>
        </select>

        <select
          style={styles.input}
          value={newAlert.estado || ''}
          onChange={(e) => setNewAlert({ ...newAlert, estado: e.target.value })}
        >
          <option value="">Estado</option>
          <option value="Activa">Activa</option>
          <option value="En seguimiento">En seguimiento</option>
          <option value="Resuelta">Resuelta</option>
          <option value="Cerrada">Cerrada</option>
        </select>

        <input
          type="date"
          style={styles.input}
          value={newAlert.fecha || ''}
          onChange={(e) => setNewAlert({ ...newAlert, fecha: e.target.value })}
        />

        <input
          style={styles.input}
          placeholder="Etiquetas (movilización, agua, APR...)"
          value={newAlert.tags || ''}
          onChange={(e) => setNewAlert({ ...newAlert, tags: e.target.value })}
        />
      </div>

      {suggestedTags.length > 0 && (
        <div style={styles.suggestedBox}>
          <div style={styles.suggestedTitle}>Etiquetas sugeridas</div>
          <div style={styles.tagsBox}>
            {suggestedTags.map((tag) => (
              <button
                key={tag}
                style={styles.suggestedTag}
                onClick={() => agregarTag(tag)}
              >
                #{tag}
              </button>
            ))}
          </div>
        </div>
      )}

      <textarea
        style={styles.textarea}
        placeholder="Descripción — contexto, evidencia, qué está pasando territorialmente..."
        value={newAlert.descripcion || ''}
        onChange={(e) => setNewAlert({ ...newAlert, descripcion: e.target.value })}
      />

      <div style={styles.buttons}>
        <button style={styles.saveButton} onClick={guardarAlerta}>
          {editingAlertId ? 'Guardar cambios' : 'Guardar alerta'}
        </button>
        {editingAlertId && (
          <button style={styles.cancelButton} onClick={cancelarEdicionAlerta}>
            Cancelar
          </button>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    background: 'white',
    padding: '30px',
    borderRadius: '14px',
    marginBottom: '30px',
    boxShadow: '0 8px 25px rgba(0,0,0,0.08)'
  },
  title: {
    marginTop: 0,
    marginBottom: '20px',
    color: '#071a2f'
  },
  actorBox: {
    background: '#fef9f0',
    border: '1px solid #fcd34d',
    borderRadius: '12px',
    padding: '18px',
    marginBottom: '20px'
  },
  actorLabel: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#92400e',
    marginBottom: '10px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  actorSelect: {
    width: '100%',
    padding: '14px',
    borderRadius: '10px',
    border: '1px solid #fcd34d',
    fontSize: '15px',
    background: 'white'
  },
  actorPreview: {
    marginTop: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  actorNombre: {
    fontWeight: 'bold',
    color: '#92400e',
    fontSize: '15px'
  },
  actorMeta: {
    color: '#667085',
    fontSize: '13px'
  },
  actorNota: {
    color: '#d97706',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '14px',
    marginBottom: '20px'
  },
  input: {
    padding: '14px',
    borderRadius: '10px',
    border: '1px solid #d0d5dd',
    fontSize: '14px'
  },
  suggestedBox: {
    background: '#f8fafc',
    border: '1px solid #e4e7ec',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '20px'
  },
  suggestedTitle: {
    fontWeight: 'bold',
    marginBottom: '12px',
    fontSize: '13px'
  },
  tagsBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  suggestedTag: {
    background: '#e0f2fe',
    color: '#075985',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '999px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 'bold'
  },
  textarea: {
    width: '100%',
    minHeight: '120px',
    padding: '14px',
    borderRadius: '10px',
    border: '1px solid #d0d5dd',
    marginBottom: '20px',
    boxSizing: 'border-box',
    fontSize: '14px',
    lineHeight: '1.5'
  },
  buttons: {
    display: 'flex',
    gap: '10px'
  },
  saveButton: {
    background: '#b45309',
    color: 'white',
    border: 'none',
    padding: '14px 22px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  cancelButton: {
    background: '#d92d20',
    color: 'white',
    border: 'none',
    padding: '14px 22px',
    borderRadius: '10px',
    cursor: 'pointer',
    fontWeight: 'bold'
  }
};

export default AlertForm;